<template>
  <div class="d-flex flex-column bg-blur-dark">
    <div class="p-3 bg-blur-darker text-center">
      <h4 class="text-white mb-0">{{ $t('js.backend.live.slide_navigation') }}</h4>
    </div>
    <button v-if="activeSlide" @click.prevent="putStopLive" :disabled="navigationDisabled"
            class="btn btn-sm btn-danger rounded-0"><i class="fas fa-video-slash me-2"></i> {{
      $t('js.backend.live.stop_live') }}
    </button>
    <div class="d-flex flex-grow-1 p-2 flex-column pretty-scroll-theme" style="overflow-y: auto; height: 0">
      <SlideNavigation v-for="slide in slides" :key="slide.id" :slide="slide"
                       :active="activeSlide && slide.id === activeSlide.id" :disabled="navigationDisabled"
                       @goToSlide="putGoToSlide"/>
    </div>
  </div>
</template>
<script>
import SlideNavigation from "./SlideNavigation.vue"

export default {
  name: 'SlideNavigationList',
  components: {SlideNavigation},
  props: {
    navigationDisabled: {},
    putGoToSlide: {},
    putStopLive: {},
    activeSlide: {},
    slides: Array,
  }
}
</script>